






































import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { UserModule } from '@/store/modules/user'
import Hamburger from '@/components/Hamburger/index.vue'
import Cookies from 'js-cookie'
import Password from '../components/password.vue'

@Component({
  name: 'Navbar',
  components: {
    Hamburger,
    Password,
  },
})
export default class extends Vue {
  private shopShow = false
  private dialogFormVisible = false

  get sidebar() {
    return AppModule.sidebar
  }

  get name() {
    return (UserModule.userInfo as any).name
      ? (UserModule.userInfo as any).name
      : JSON.parse(Cookies.get('user_info') as any).name
  }

  private toggleSideBar() {
    AppModule.ToggleSideBar(false)
  }

  private async logout() {
    this.$store.dispatch('LogOut').then(() => {
      this.$router.replace({ path: '/login' })
    })
  }

  toggleShow() {
    this.shopShow = true
  }

  mouseLeaves() {
    this.shopShow = false
  }

  handlePwd() {
    this.dialogFormVisible = true
  }

  handlePwdClose() {
    this.dialogFormVisible = false
  }
}
